export const EstadoSolicitud = Object.freeze({
  revisionpp: 1,
  aceptada: 2,
  rechazada: 3,
  reclamacion: 4,
  rechazadapp: 5,
  revisionservel: 6
});
